export default __webpack_public_path__ + "static/media/TW.7f28d8d8.svg";